<template>
  <announcement v-if="verifyStatus === LX_CERTIFICATION_STATUS['FAIL']" announceType="warning">
    您的上一次认证失败，请修改信息后重试。 失败原因：{{ userInfo.reasons.join('；') }}
  </announcement>
  <announcement v-else-if="isHighSchool && verifyStatus === LX_CERTIFICATION_STATUS['INIT']" announceType="warning">
    请上传高考准考证照片。
    <br />
    保证姓名、学校、考试年份等信息清晰可见。
  </announcement>
  <announcement v-else-if="verifyStatus === LX_CERTIFICATION_STATUS['PENDING']" announceType="info">
    认证审核中，预计
    <span class="announcement-time">
      {{ formattedTime }}
    </span>
    前完成审核。
  </announcement>
</template>

<script setup>
import { computed } from 'vue'
import Announcement from './Announcement'
import format from 'date-fns/format'
import add from 'date-fns/add'
import { LX_CERTIFICATION_STATUS } from './utils'

const props = defineProps({
  verifyStatus: {
    type: Number,
    default: 0,
    required: true,
  },
  userInfo: {
    type: Object,
    default: () => ({}),
    required: true,
  },
  isHighSchool: {
    type: Boolean,
    default: false,
  },
})
// 预计审核完成时间
const formattedTime = computed(
  () => props.userInfo.gmtCreate && format(add(props.userInfo.gmtCreate, { days: 3 }), 'yyyy.MM.dd HH:mm'),
)
</script>

<style scoped lang="less">
.announcement-time {
  font-weight: 600;
  line-height: 18px;
}
</style>
